
import PropTypes from 'prop-types'
import { Form, Button } from 'antd'

function SubmitButton({
  children = null,
  isSubmitting,
  isValid,
  noWrapper = false,
  title = undefined,
  wrapperCol = undefined,
  ...rest
}) {
  const button = (
    <Button
      type="primary"
      htmlType="submit"
      disabled={isSubmitting}
      loading={isSubmitting}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {children || title}
    </Button>
  )
  if (noWrapper) return button
  return <Form.Item wrapperCol={wrapperCol}>{button}</Form.Item>
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  errors: PropTypes.shape({}),
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  noWrapper: PropTypes.bool,
  style: PropTypes.shape({}),
  title: PropTypes.string,
  wrapperCol: PropTypes.shape({}),
}

export default SubmitButton
